import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import Spinner from "../Reusable/Spinner";
import TextField from "../Reusable/TextInput";
import ChangeStatus from "./ChangeStatus";

const EditDelivery = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [statusData, setStatusData] = useState(null);

  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    isPrintLoading,
    handleToggleMarkAsDone,
    handleRemove,
    isRemoved,
    gridData,
    handleStatusChange,
    defaultValue,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createRunsheetValidationForm),
    defaultValues: async () => {
      return {
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        vehicle: {
          name: data?.vehicle?.license_number,
          id: data?.vehicle?.id,
        },
        note: data?.note,
      };
    },
  });
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      if (!data?.is_active) {
        toast.error("Order can't be received here");
      } else if (statusData?.length > 1 && defaultValue?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          defaultValue[0]?.id,
          setError,
        );
      } else if (statusData?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          statusData[0]?.id,
          setError,
        );
      } else {
        toast.error("Please select one status first");
      }
      event.target.value = "";
    }
  };
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };
  const defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "Waybill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Vendor",
      accessorKey: "order.vendor.user.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },

    {
      header: "Customer",
      accessorKey: "order.receiver.full_name",
      cell: NACell,
    },

    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Weight/Pcs",
      accessorKey: "order.weight",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  const handleOrderDetailNavigate = () => {
    // window.location.replace(`/order#/edit/${row?.original?.order?.id}`)
    console.log();
  };

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  useEffect(() => {
    {
      gridData?.map((x) => {
        if (x?.name === "Final") {
          setStatusData(x?.status_id);
        }
      });
    }
  }, [gridData]);

  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={!data?.is_active}
          >
            <div className={tw`grid md:grid-cols-3 gap-x-4 mx-4`}>
              <ComboboxInput
                url={APIS.VEHICLE}
                queryKey={"vehicle"}
                register={register("vehicle")}
                errors={errors?.vehicle}
                name={"vehicle"}
                label={"Vehicle Number"}
                setValue={setValue}
                placeholder={"Search vehicle"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <ComboboxInput
                url={APIS.DRIVER}
                queryKey={"driver"}
                register={register("driver")}
                errors={errors?.driver}
                name={"driver"}
                label={"Driver"}
                setValue={setValue}
                placeholder={"Search driver"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <div className={tw`mx-4`}>
                <TextField
                  label={"Note"}
                  register={register(`note`, { disabled: !data?.is_active })}
                  errors={errors?.note}
                />
              </div>
            </div>
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_runsheet"]}
      />
      <Card title="Barcode Scanner">
        <>
          <div className={tw`flex flex-col relative -top-6 items-end w-full`}>
            <ChangeStatus
              handleAttachConsignment={handleAttachConsignment}
              gridData={statusData}
              handleStatusChange={handleStatusChange}
            />
          </div>
          <div className={tw`grid grid-cols-1 w-full`}>
            <div>
              <input
                type="text"
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                {...register("tracking_number")}
                onPaste={preventCopyPaste}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        </>
      </Card>
      <DataTable
        url={APIS.DELIVERY_ITEMS}
        queryKey={"runsheet-items"}
        tableName="runsheet-table"
        columns={defaultColumns}
        params={{ delivery: data?.id }}
        handleDetailNavigate={handleOrderDetailNavigate}
        actionMenu={
          <div className={tw`w-full text-right`}>
            {data?.is_active ? (
              <button
                className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                onClick={handleToggleMarkAsDone}
              >
                Mark As Done
              </button>
            ) : (
              ""
            )}
            <button
              className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
              disabled={isPrintLoading}
              onClick={() => handlePrint()}
            >
              {isPrintLoading ? <Spinner /> : "Print"}
            </button>
            {data?.is_active ? (
              <button
                className={tw`p-1 px-5  rounded-sm border border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                disabled={isRemoved}
                onClick={() => handleRemove()}
              >
                {isRemoved ? <Spinner /> : "Remove"}
              </button>
            ) : (
              ""
            )}
          </div>
        }
      />
    </>
  );
};
export default EditDelivery;
